import header from '../views/common/header';
import gnb from '../views/common/gnb';

export default [
  {
    path: '/views/extra/auth/rtrck-summary',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/extra/auth/role-tracker/RtrckSummaryNeo.vue'),
      header,
      gnb,
    },
  },
  {
    path: '/views/extra/auth/rtrck-summary/:systemId',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/extra/auth/role-tracker/RtrckSummaryNeo.vue'),
      header,
      gnb,
    },
  },
  {
    path: '/views/extra/auth/rtrck-summary-detail',
    meta: { fixedMinSize: false },
    components: {
      default: () => import('../views/extra/auth/role-tracker/SummaryDetail.vue'),
    },
  },
  {
    path: '/views/extra/auth/rtrck-search',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/extra/auth/role-tracker/RtrckSearchNeo.vue'),
      header,
      gnb,
    },
  },
  {
    path: '/views/extra/auth/rtrck-search/:systemId',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/extra/auth/role-tracker/RtrckSearchNeo.vue'),
      header,
      gnb,
    },
  },
  {
    path: '/views/extra/auth/rtrck-search-detail',
    meta: { fixedMinSize: false },
    components: {
      default: () => import('../views/extra/auth/role-tracker/SearchDetail.vue'),
    },
  },
  {
    path: '/views/extra/auth/sod',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/extra/auth/sod'),
      header,
      gnb,
    },
  },
  {
    path: '/views/extra/auth/sod/:systemId',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/extra/auth/sod'),
      header,
      gnb,
    },
  },
];
